import type { UUID, ISODateString } from './common';

export const PERSON_KEYS = ['person1', 'person2', 'guests', 'wedding_party'] as const;
export type PersonKey = (typeof PERSON_KEYS)[number];

export const PERSON_KEY_LABELS: Record<PersonKey, string> = {
  person1: 'Person 1',
  person2: 'Person 2',
  guests: 'Guests',
  wedding_party: 'Wedding party',
};

export const EVENT_TEMPLATE_KINDS = [
  'wedding_ceremony',
  'reception',
  'rehearsal_dinner',
  'welcome_dinner',
  'brunch',
  'custom',
] as const;
export type EventTemplateKind = (typeof EVENT_TEMPLATE_KINDS)[number];

export const EVENT_TEMPLATE_KIND_LABELS: Record<EventTemplateKind, string> = {
  wedding_ceremony: 'Wedding ceremony',
  reception: 'Reception',
  rehearsal_dinner: 'Rehearsal dinner',
  welcome_dinner: 'Welcome dinner',
  brunch: 'Brunch',
  custom: 'Custom',
};

export interface Event {
  id: UUID;
  projectId: UUID;
  name: string;
  description: string | null;
  startAt: ISODateString;
  endAt: ISODateString;
  timezone: string;
  location: string | null;
  sortOrder: number;
  createdAt: ISODateString;
  updatedAt: ISODateString;
}

export interface EventTimelineStep {
  id: UUID;
  eventId: UUID;
  title: string;
  category: string | null;
  startAt: ISODateString;
  endAt: ISODateString | null;
  bodyJson: unknown | null;
  bodyText: string | null;
  includeInSummary: boolean;
  sortOrder: number;
  createdAt: ISODateString;
  updatedAt: ISODateString;
}

export interface EventStepParticipant {
  id: UUID;
  stepId: UUID;
  projectVendorId: UUID | null;
  personKey: PersonKey | null;
  freeText: string | null;
  role: string | null;
  createdAt: ISODateString;
}
